import { isSelfServiceDevelopment } from '../../../lib/env';

// The publisher Billing tab flag (CTV-776), the successor of the #1333 payout
// kill switch.
//
// Why this exists: Stripe Connect is not yet enabled on the LIVE platform
// account. Until it is, "Connect bank account" fails inside Stripe with a
// developer-facing message telling the PUBLISHER to go sign up for Connect at
// dashboard.stripe.com, which is both wrong and alarming on the first screen a
// new station sees. So the whole publisher-facing money surface (the Billing
// tab with its payout ledger and Stripe setup section, the "Payouts not set
// up" banner, the red dot on the nav item) is shown in development and hidden
// in production.
//
// Nothing underneath is disabled: the settlement engine, the readiness
// predicate and POST /publisher-billing/summary all keep working.
//
// TO FLIP once Connect is live on the live platform: return true, ship, then
// delete this file and the call sites. Verify by clicking "Connect bank
// account" on a station and seeing Stripe's hosted onboarding instead of a red
// error.
//
// Deliberately a function rather than a bare const so specs can mock it.
export function publisherBillingEnabled(): boolean {
  return isSelfServiceDevelopment();
}
